import { camelCaseToSnakeCase, snakeCaseToCamelCase } from '../string'

export const isObject = val => ({}.toString.call(val) === '[object Object]')

export const isEmptyObject = obj => !obj || Object.keys(obj).length === 0

export const objectHasValues = obj => !!obj && Object.keys(obj).some(key => obj[key] != null)

const keysTo = (o, transformer) => {
  if (isObject(o)) {
    const n = {}

    Object.keys(o).forEach(k => {
      n[transformer(k)] = keysTo(o[k], transformer)
    })

    return n
  } else if (Array.isArray(o)) {
    return o.map(i => {
      return keysTo(i, transformer)
    })
  }

  return o
}

export const keysToCamelCase = o => keysTo(o, snakeCaseToCamelCase)

export const keysToSnakeCase = o => keysTo(o, camelCaseToSnakeCase)

export const pick = (...keys) => {
  return origin =>
    keys.reduce(
      (target, key) => ({
        ...target,
        [key]: origin[key]
      }),
      {}
    )
}

export const get = (dotKey = '', obj, defaultValue) => {
  const value = dotKey.split('.').reduce((child, key) => {
    return typeof child === 'object' && child !== null ? child[key] : undefined
  }, obj)

  return value != null ? value : defaultValue
}

export const set = (dotKey = '', obj, value) => {
  const path = dotKey.split('.')
  let i = 0

  for (; i < path.length - 1; i++) {
    if (obj[path[i]] === null || typeof obj[path[i]] === 'undefined') {
      obj[path[i]] = {}
    }

    obj = obj[path[i]]
  }

  obj[path[i]] = value
}

export function mapObjectValues(mapper) {
  return source =>
    Object.keys(source).reduce(
      (target, key) => ({
        ...target,
        [key]: mapper(source[key])
      }),
      {}
    )
}
